import React from 'react';
import { AccountApiResponse, CommonPageStep, SubscriptionPageStep } from '..';
import { WindowSharp } from '@mui/icons-material';
import fetch from 'cross-fetch';
import * as qs from 'query-string';
import { Navigate } from 'react-router-dom';
import { ChooseYourPlan } from './chooseYourPlan';
import apiHelper, {
  SupportedIncomingFormat,
  SupportedMethod,
  SupportedOutgoingFormat,
  SupportedServers,
} from '../../common/ApiHelper';
import { logoutBbl } from '../../common/CommonTools';
import { appConfig } from '../../common/ConfigLoader';
import { useAppSelector } from '../../store/hooks';
import {
  AppStateAuthentication,
  selectAppAuthentication,
  selectAppPageStep,
  setAppPageStep,
  updateAppAuthentication,
  updateAppUserProfile,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export const Subscription = (): JSX.Element => {
  // Redux
  const pageStep = useAppSelector(selectAppPageStep);
  const authenticationData = useAppSelector(selectAppAuthentication);

  // LOCAL HOOKS
  const [needVerifyAuthentication, setNeedVerifyAuthentication] =
    React.useState(false);

  // Page Functions
  const resumeUserSession = (): void => {
    const parmsValue = qs.parse(window.location.search);

    // Get session info from session storage
    const bigbangSessionInfo = window.localStorage.getItem(
      'bigbang_session_info',
    );
    const previousSessionInfo = JSON.parse(
      bigbangSessionInfo ? bigbangSessionInfo : '{}',
    ) as AppStateAuthentication;

    // Check if the session is the same as returned
    if (
      previousSessionInfo !== undefined &&
      previousSessionInfo !== null &&
      (parmsValue.clientSessionId === undefined ||
        parmsValue.clientSessionId === previousSessionInfo.sessionId)
    ) {
      console.debug('Session information matched');
      outsideComponentDispatch(updateAppAuthentication(previousSessionInfo));
    } else {
      console.error(
        'Session information not matched!!!!!!',
        previousSessionInfo,
        parmsValue,
      );
      if (previousSessionInfo.token) {
        outsideComponentDispatch(updateAppAuthentication(previousSessionInfo));
      }
    }

    setNeedVerifyAuthentication(true);
  };

  const storeUserSessionInfo = (): void => {
    const sessionInfoString = JSON.stringify({ ...authenticationData });
    window.localStorage.setItem('bigbang_session_info', sessionInfoString);
  };

  const loadUserProfile = (): void => {
    const userProfileEndpoint = 'user/UserProfile';
    void apiHelper(
      SupportedServers.ACCOUNT,
      userProfileEndpoint,
      SupportedMethod.POST,
      {},
      {
        incomingFormat: SupportedIncomingFormat.JSON,
        outgoingFormat: SupportedOutgoingFormat.JSON,
        headerConstructor() {
          return {
            authorization: authenticationData ? authenticationData.token : '',
          };
        },
      },
    ).then(async (result: AccountApiResponse): Promise<void> => {
      console.log(result);
      if (result.success) {
        outsideComponentDispatch(updateAppUserProfile(result.data));
      }
    });
  };

  React.useEffect((): void => {
    outsideComponentDispatch(
      setAppPageStep(SubscriptionPageStep.CHOOSE_YOUR_PLAN),
    );

    resumeUserSession();
    if (authenticationData) {
      storeUserSessionInfo();
      loadUserProfile();
    } else {
      logoutBbl();
    }
  }, []);

  React.useEffect((): void => {
    if (needVerifyAuthentication) {
      if (!authenticationData) {
        window.location.href = '/Login';
      }
    }
  }, [authenticationData, needVerifyAuthentication]);

  return (
    <React.Fragment>
      {pageStep === SubscriptionPageStep.CHOOSE_YOUR_PLAN ? (
        <ChooseYourPlan />
      ) : null}
    </React.Fragment>
  );
};
